module.exports = __webpack_public_path__ + "static/media/cargo.ccbe844d.png";